import { useState } from 'react'

// Vinissimus Backoffice auth
export class AuthToken {
  constructor(url) {
    const [state, setState] = useState({
      token: null,
      logged: undefined,
    })

    this.guillotina = url
    this.state = state
    this.setState = setState
  }

  getToken() {
    // this method is expected by GuillotinaClient
    return this.state.token
  }

  get isLogged() {
    const { logged, token } = this.state
    // Can return undefined/false/true
    return logged === true ? !!token : logged
  }

  async authGetToken() {
    const resp = await fetch('/v2/auth/get_token')
    const data = await resp.json()
    const token = data.token
    this.setState({ token })
    localStorage.setItem('ctoken', token)
  }

  async ensureLogin() {
    if (this.isLogged) {
      return this.isLogged
    }

    // try to fetch token from localstorage
    let token = localStorage.getItem('token')
    console.log('token', token)
    if (!token) {
      const logged = false
      this.setState({ logged, token: null })
      return logged
    }

    const resp = await fetch(`${this.guillotina}`, {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })

    const logged = resp.status === 200
    if (logged) this.setState({ logged, token })
    else {
      this.setState({ logged, token: null })
      localStorage.removeItem('token')
    }
    return logged
  }

  async login(username, password) {
    const tresp = await fetch('/v2/auth/get_token')
    let data = await tresp.json()
    const resp = await fetch(`/v2/auth/login`, {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + data.token,
      },
      body: JSON.stringify({
        email: username,
        password,
      }),
    })

    if (resp.status !== 200) {
      throw new Error('Invalid Login')
    }

    data = await resp.json()
    localStorage.setItem('token', data.token)
    localStorage.setItem('email', username)
    this.setState({ logged: true, token: data.token })
    return data
  }

  async logout() {
    const { token } = this.state
    localStorage.removeItem('token')
    localStorage.removeItem('email')
    this.setState({ logged: false, token: null })
    await fetch('/v2/auth/logout', {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
  }
}
